import React from "react";
import { OrSeparator } from "./SocialLogin";
import { LoginProvider } from "./login/provider";
import { GoogleAuthenticationLogin, UpsolverAuthenticationLogin } from "./login/components";
import { AzureAuthenticationLogin } from "./login/azure";
import UserTrackingEvent from "../analytics/UserTrackingEvent";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { OrganizationSelectList } from "./UserOrganizations";
import { OrganizationSelectProps } from "./login/provider/LoginProvider";
import { useHistory } from "react-router";


function PostRedirectMulti({organizations, onSelect}: OrganizationSelectProps) {
  const history = useHistory();
  return <Container maxWidth="sm">
    <Box p={1}>
      <Box>
        <Typography variant="h5">Select Organization</Typography>
      </Box>
      <OrganizationSelectList
        organizations={organizations}
        gotoDefault={true}
        onSelect={(org) => {
          onSelect(org);
          history.replace("/")
        }
        }
      />
    </Box>
  </Container>
}

/**
 * Main app login view. Email/password or google.
 * @returns {JSX.Element}
 * @constructor
 */
export default function InnerLoginView() {
  return (
    <UserTrackingEvent event="login-started">
      <LoginProvider multiOrgView={
        PostRedirectMulti
      }>
        <GoogleAuthenticationLogin />
        <AzureAuthenticationLogin />
        <OrSeparator />
        <UpsolverAuthenticationLogin />
      </LoginProvider>
    </UserTrackingEvent>
  );
}
